// extracted by mini-css-extract-plugin
module.exports = {"formControl":"PaymentMethodForm_formControl__1jEyC","disabled":"PaymentMethodForm_disabled__6ZMLf","label":"PaymentMethodForm_label__3_m_-"};